export const menuState = (state) => () => {
  var array=[];
  array.push(!state);
  return array;
};
